import React, { Component } from "react";
import AntdMention, {MentionProps} from 'antd/lib/mention';
import 'antd/lib/mention/style';

const { Nav, getMentions, toString, toContentState } = AntdMention;
interface FMProps extends MentionProps {
    forwardedRef?: any;
}
class FdxMention extends Component<FMProps> {
    render() {
        const { forwardedRef, ...rest } = this.props;
        return (
          <AntdMention ref={forwardedRef} {...rest} />
        )
    }
}

const Mention: any = React.forwardRef((props: FMProps, ref) => {
    return <FdxMention {...props} forwardedRef={ref} />
});

Mention.Nav = Nav;
Mention.getMentions = getMentions;
Mention.toString = toString;
Mention.toContentState = toContentState;
export default Mention





// WEBPACK FOOTER //
// ./src/components/mention/index.tsx